import React from "react";
import MenuItem from "@mui/material/MenuItem";
import CustomTextField from "./CustomTextField";

const CustomDropDown = ({ options, ...props }) => {
  return (
    <CustomTextField select="true" {...props}>
      {options?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </CustomTextField>
  );
};

export default CustomDropDown;
